import { Checkbox, Col, Flex, Form, message } from "antd";
import React from "react";
import {
  FullHeightRow,
  StyledButton,
  StyledInput,
  StyledLink,
  StyledPasswordInput,
} from "../../components/styledComponent/styledElements";
import { AiOutlineUser } from "react-icons/ai";
import { MdPassword } from "react-icons/md";
import loginLogo from "../../assets/images/Logo.svg";
import { useNavigate } from "react-router-dom";
import { login } from "../../server/authServer";

function LoginPage() {
  const navigate = useNavigate();

  const onSubmit = ({ username, password, remember }) => {
    login({ username, password, remember })
      .then((res) => {
        message.success("Successfully Logged In");
        navigate("/", { replace: true });
      })
      .catch((err) => {
        console.log(err);
        message.error("Invalid username or password");
      });
  };
  return (
    <FullHeightRow className="space-around login-page">
      <Col md={20} lg={10} sm={22} className="login-div">
        <Form className="loginForm" onFinish={onSubmit}>
          <div className="mb-2">
            <img src={loginLogo} alt="partspal logo" />
          </div>
          <Form.Item
            name={"username"}
            rules={[{ required: true, message: "Please enter username !" }]}
          >
            <StyledInput
              placeholder="Enter your username"
              width={"100%"}
              prefix={
                <AiOutlineUser
                  style={{
                    color: "rgba(0,0,0,.25)",
                  }}
                />
              }
            />
          </Form.Item>
          <Form.Item
            name={"password"}
            rules={[{ required: true, message: "Please enter password !" }]}
          >
            <StyledPasswordInput
              prefix={<MdPassword style={{ color: "rgba(0,0,0,.25)" }} />}
              placeholder="Enter your password"
              width={"100%"}
            />
          </Form.Item>
          <Flex className="mb-8" justify="space-between" align="center">
            <Form.Item name="remember" valuePropName="checked" noStyle>
              <Checkbox value={false}>Remember me</Checkbox>
            </Form.Item>
            <a href="#Forgot password">Forgot password?</a>
          </Flex>
          <Form.Item>
            <StyledButton htmlType="submit" width={"100%"}>
              Login
            </StyledButton>
          </Form.Item>
          <div className="text-center mt-2">
            <p>
              New to partspal?
              <span onClick={() => navigate("/signup", { replace: true })}>
                <StyledLink>Sign Up</StyledLink>
              </span>
            </p>
          </div>
        </Form>
      </Col>
    </FullHeightRow>
  );
}

export default LoginPage;
